import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface IndustryItem {
    label: string;
    section: string;
}


interface Props extends WidgetProps {
    fields: {
        industries: IndustryItem[];
    };
}

const styles: {
    iconGrid: InjectableCss;
    iconItem: InjectableCss;
    iconImage: InjectableCss;
    iconLabel: InjectableCss;
    section?: InjectableCss;
} = {
    iconGrid: {
        css: css`
            gap: 20px !important;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            max-width: 1000px;
            background: transparent;
            padding: 0;
            >div{
            justify-content: center;
            }
        `,
    },
    iconItem: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100px;
            text-align: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding-top: 5px;
                        padding-bottom: 0px;
                    `,
                    null,
                    null,
                ],"max")}
        `,
    },
    iconImage: {
        css: css`
            width: 100%;
            height: auto;
            margin-bottom: 2px;
            object-fit: contain;
            border-radius: 5px;
        `,
    },
    iconLabel: {
        css: css`
            font-family: Barlow-Regular;
            font-size: 16px;
            line-height: normal;
            color: #ffffff;
            text-transform: uppercase;
            font-weight: 600;
            margin-top: 5px;
            margin-bottom: 5px;
            border: 2px solid #ffffff;
            width: 100%;
            padding: 15px 10px;
            background: #003c70;
            span{
                font-size: 16px;
            }
            &:hover{
                color: #005bac;
                background: #ffffff;
                border: 2px solid #005bac;
            }
        `,
    },
    section:{
        css:css`
        font-size: 14px;
        text-align: center;
        `
    }
};

export const IndustriesServedGridTest: React.FC<Props> = ({ fields }) => {
   
    let industries = (fields.industries || []).map(item =>
        (item as any).fields ? (item as any).fields : item
    );

    function sectionRedirectHandler(section: string) {
  const el = document.getElementById(section);
  if (el) {
    const offset = 50; // offset in pixels
    const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

    return (
        <GridContainer {...styles.iconGrid}>
            {industries.map((industry, idx) =>{
                return (
                <GridItem width={[12,6,6,3,3]} {...styles.iconItem} key={idx}>
                    <Button {...styles.iconLabel} onClick={()=>{
                        sectionRedirectHandler(industry.section)
                    }}>
                        {industry.label}
                    </Button>
                </GridItem>
            )})}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: IndustriesServedGridTest,
    definition: {
        group: "Basic",
        icon: "image",
        displayName: "About us Section Redirect Button",
        fieldDefinitions: [
            {
                name: "industries",
                displayName: "Industries",
                editorTemplate: "ListField",
                fieldType: "Contextual",
                getDisplay: ({ fields: { label } }) => label || "Section",
                fieldDefinitions: [ 
                    {
                        name: "label",
                        displayName: "Label",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "section",
                        displayName: "Section ID",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
                defaultValue: [],
            },
],
    },
};

export default widgetModule;